<template>
  <a-modal title="推广汇总" :visible="innerVisible" :width="700" :footer="null" @cancel="close">
    <div class="summaryArea">
      <a-table class="ant-table-striped" :columns="columns" :data-source="data"
        :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="promoter"
        :scroll="{ x: 600 }" :pagination="false">
        <template #footer>
          <div style="text-align: right; padding-right: 15px;">
            合计：<b>{{ total }}</b>
          </div>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { PromotionSummary } from "/src/api/wechatOA.js";

export default {
  name: "推广汇总",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dateRange: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:visible"],
  data() {
    return {
      data: [],
      columns: [
        { title: "推广员", dataIndex: "employeeName", key: "employeeName", width: 200 },
        { title: "客户数", dataIndex: "promotionCount", key: "promotionCount", width: 150 },
      ],
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    total() {
      return this.data.reduce((sum, item) => sum + (item?.promotionCount || 0), 0);
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadSummary();
      } else {
        this.data = [];
      }
    },
  },
  methods: {
    close() {
      this.innerVisible = false;
    },
    getRange() {
      const from = this.dateRange && this.dateRange[0] ? this.dateRange[0].format("YYYY-MM-DD") : undefined;
      const to = this.dateRange && this.dateRange[1] ? this.dateRange[1].format("YYYY-MM-DD") : undefined;
      return { dateFrom: from, dateTo: to };
    },
    async loadSummary() {
      try {
        const range = this.getRange();
        const res = await PromotionSummary(range);
        if (res.errCode === 0) {
          this.data = Array.isArray(res.data) ? res.data : [];
        }
      } catch (error) {
        console.error(error);
        this.$message && this.$message.error("汇总查询失败");
      }
    },
  },
};
</script>

<style scoped>
.summaryArea {
  background-color: #fff;
}
</style>